module.exports = __webpack_public_path__ + "img/bg_01.ae161067.jpg";